import React from "react";

const BreadcrumbItem = ({ title, url, position, classes, isActive = false }) => (
    <li
        className={`breadcrumb__item ${isActive ? "breadcrumb__item--active" : ""} ${classes}`}
        aria-current={isActive ? "page" : undefined}
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
    >
        {url ? (
            <a href={url} title={title} itemProp="item" itemScope itemType="http://schema.org/Thing" itemID={url}>
                <span itemProp="name">{title}</span>
            </a>
        ) : (
            <span itemProp="name">{title}</span>
        )}
        <meta itemProp="position" content={position} />
    </li>
);

export default BreadcrumbItem;
